<template>
  <div class="print-break-after">
    <!-- 
      Div a scomparsa per mostrare un'immagine utilizzando tutta la finestra popup
    -->
    <div v-if="tabToShow === 'pic'" class="wg-row pic-viewer">
      <picture-viewer
        v-if="!showDrawer"
        :picToShow="picToShow"
      ></picture-viewer>
      <picture-drawer
        v-else
        :picToShow="picToShow"
        :projectId="projectId"
        @addImage="addImage"
        @closeDrawer="closePic"
      ></picture-drawer>
      <img
        v-if="!(!this.project.category || (this.project.category != 2 && this.project.category != 10))"
        :src="$anm22.icons.getWorldIcon('edit')"
        class="edit-pic"
        @click="showDrawer = true"
      />
      <img
        :src="$anm22.icons.getWorldIcon('deleteBlack')"
        class="close-pic"
        @click="closePic"
      />
    </div>
    <!-- 
      Div principale
    -->
    <div v-show="tabToShow === 'default'" class="wg-row">
      <template v-if="!this.project.category || (this.project.category != 2 && this.project.category != 10)">
        <template v-if="mode != 'prod'">
          <div class="wg-row input-row" style="height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(lang, "Origin folder", "Cartella di origine")
                }}
              </div>
            </div>
            <div class="wg-col wg-xs-9">
              <input
                :disabled="mode === 'view'"
                class="input-elem com-anm22-app-input-text"
                type="text"
                v-model="formData.originFolder"
              />
            </div>
          </div>
          <div class="wg-row" style="margin-bottom: 12px;">
            <div class="wg-col wg-xs-12 wg-sm-6">
              <div class="wg-row input-row">
                <div class="com-anm22-app-text-m">
                  {{
                    $anm22.strLang(lang, "Top base size", "Taglia base sopra")
                  }}
                </div>
                <select
                  class="input-elem com-anm22-app-select"
                  :disabled="!(mode === 'edit')"
                  v-model="sheetData.sizeTop"
                >
                  <option
                    v-for="(model, index) in sizesList"
                    :key="'modelsizeTop-' + index"
                    :value="model.size"
                    >{{ model.size }}</option
                  >
                </select>
              </div>
            </div>
            <div class="wg-col wg-xs-12 wg-sm-6">
              <div class="wg-row input-row">
                <div class="com-anm22-app-text-m">
                  {{
                    $anm22.strLang(
                      lang,
                      "Bottom base size",
                      "Taglia base sotto"
                    )
                  }}
                </div>
                <select
                  class="input-elem com-anm22-app-select"
                  v-model="sheetData.sizeBottom"
                >
                  <option
                    v-for="(model, index) in sizesList"
                    :key="'modelsizeBottom-' + index"
                    :value="model.size"
                    :disabled="!(mode === 'edit')"
                    >{{ model.size }}</option
                  >
                </select>
              </div>
            </div>
          </div>
          <div class="wg-row input-row" style="min-height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Graphic design technique",
                    "Tecnica di realizzazione grafica"
                  )
                }}
              </div>
            </div>
            <div class="wg-col wg-xs-9">
              <div class="wg-row" style="align-items:center;">
                <input
                  v-if="formData.printTreatment == 1"
                  :disabled="mode === 'view'"
                  id="treatment-1"
                  type="radio"
                  value="1"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label
                  v-if="formData.printTreatment == 1"
                  class="label-input-radio"
                  for="treatment-1"
                  >{{ formData.printTreatment == 1 ? "✔" : "" }}</label
                >
                <div
                  v-if="formData.printTreatment == 1"
                  class="com-anm22-app-text-m"
                  style="margin:0 5px;"
                >
                  {{ $anm22.strLang(lang, "Old flag", "Vecchio flag") }}
                </div>
                <div
                  v-if="formData.printTreatment == 1"
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="treatment-sewn"
                  type="radio"
                  value="sewn"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label class="label-input-radio" for="treatment-sewn">{{
                  formData.printTreatment === "lorica" ||
                  formData.printTreatment === "sewn"
                    ? "✔"
                    : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Sewn logos", "Loghi cuciti") }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="treatment-print"
                  type="radio"
                  value="directPrint"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label class="label-input-radio" for="treatment-print">{{
                  formData.printTreatment === "directPrint" ||
                  formData.printTreatment === "transfer" ||
                  formData.printTreatment === "uv"
                    ? "✔"
                    : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{
                    $anm22.strLang(
                      lang,
                      "Direct print logos",
                      "Loghi stampa diretta"
                    )
                  }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="treatment-custom"
                  type="radio"
                  value="fullCustom"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label class="label-input-radio" for="treatment-custom">{{
                  formData.printTreatment === "fullCustom" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Full custom", "Full custom") }}
                </div>
                <template v-if="formData.printTreatment === 'fullCustom'">
                  <div class="vertical-height-div" style="height:10px;"></div>
                  <div class="wg-col wg-xs-12 wg-sm-6">
                    <textarea
                      :disabled="mode === 'view'"
                      class="input-elem com-anm22-app-textarea print-note model-row"
                      style="height:100px;width:100%;max-width:unset;"
                      v-model.lazy="formData.printTreatmentCustom"
                    ></textarea></div
                ></template>
              </div>
            </div>
          </div>
          <div class="wg-row input-row" style="height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Perforations", "Traforatura") }}
              </div>
            </div>
            <div class="wg-col wg-xs-9">
              <div class="wg-row" style="align-items:center;">
                <input
                  :disabled="mode === 'view'"
                  id="perf-y"
                  type="radio"
                  value="y"
                  style="display:none;"
                  v-model="formData.perforations"
                />
                <label class="label-input-radio" for="perf-y">{{
                  formData.perforations === "y" ||
                  formData.perforations === "medium" ||
                  formData.perforations === "total" ||
                  formData.perforations === "beforePrint" ||
                  formData.perforations === "afterPrint"
                    ? "✔"
                    : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Yes", "Si") }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="perf-no"
                  type="radio"
                  value="no"
                  style="display:none;"
                  v-model="formData.perforations"
                />
                <label class="label-input-radio" for="perf-no">{{
                  formData.perforations === "no" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "No", "No") }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <div class="wg-row" v-if="mode === 'prod'">
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Save', 'Salva')"
          @click="saveForm"
        />
        <div class="vertical-height-div" style="height:10px;"></div>
      </div>
      <!-- NOTE -->
      <div class="wg-row input-row" v-if="mode != 'prod'">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <textarea
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-textarea print-note model-row"
            style="height:100px;width:100%;max-width:unset;"
            v-model.lazy="formData.notes2"
          ></textarea>
        </div>
      </div>
      <!-- INVIO NOTIFICHE -->
      <div
        v-if="
          mode != 'prod' &&
            (docs.data.company == 'vrs' || docs.data.company == 'rvt') &&
            (formData.images || formData.notificationDesign)
        "
        class="wg-row input-row no-print"
      >
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Design email", "Email con design") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div
          v-if="notificationSended || formData.notificationDesign"
          class="wg-col wg-xs-12 wg-sm-6"
        >
          <div class="vircos-notification-sended">
            <img :src="$anm22.icons.getWorldIcon('check')" />
            {{ $anm22.strLang(lang, "Sended", "Inviata") }}
            {{
              $moment
                .unix(formData.notificationDesign)
                .format("DD/MM/YYYY HH:mm")
            }}
          </div>
        </div>
        <div v-else class="wg-col wg-xs-12 wg-sm-6">
          <div
            @click="sendShareNotification()"
            class="vircos-notification-send-btn"
          >
            <img :src="$anm22.icons.getWorldIcon('send')" />
            {{ $anm22.strLang(lang, "Send", "Invia") }}
          </div>
        </div>
      </div>
      <div class="wg-row input-row" v-if="mode != 'prod'">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Last edit", "Ultima modifica") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ lastEditDate + " " + lastEditUser }}
          </div>
        </div>
      </div>
      <template v-if="mode === 'edit' || mode === 'prod'">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, "Attachment", "Allegato") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <template v-if="graphicImages">
            <div
              v-for="(img, index) in graphicImages.filter((i) => i)"
              :key="'img-' + index"
              style="position:relative;height:100px;width:100px;margin:5px;cursor:pointer;"
            >
              <img
                style="height:100%;width:100%;"
                :src="$anm22.getImagePath(img)"
                @click="showPic(img)"
              />
              <img
                v-if="mode === 'edit'"
                class="com-anm22-app-img-fixed-height-m"
                style="position:absolute;top:3px;right:3px;"
                :src="$anm22.icons.getWorldIcon('deleteBin')"
                @click="removeImage(index)"
              />
            </div>
          </template>
          <anm22-file-uploader
            v-if="mode === 'edit'"
            :uploadUrl="
              'vircos/graphics-image?idWorldProject=' + imagesProjectId
            "
            :onSuccess="addImage"
          ></anm22-file-uploader>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" v-if="mode === 'edit'">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Save', 'Salva')"
            @click="saveForm"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Anm22FileUploader from "../../../../../../world/spa/components/Anm22FileUploaderInline.vue";
import PictureDrawer from "./PictureDrawer.vue";
import PictureViewer from "./PictureViewer.vue";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    sizes: Array,
    mainProjectDocs: {
      type: Object | null,
      default: null,
    },
    mode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      formData: {},
      sheetData: {},
      tabToShow: "default",
      picToShow: null,
      showDrawer: false,
      notificationSended: false,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    useMainProjectImages() {
      if (this.docs && this.docs.data && this.docs.data.mainProjectId) {
        return true;
      } else {
        return false;
      }
    },
    graphicImages() {
      if (this.useMainProjectImages) {
        if (
          this.mainProjectDocs &&
          this.mainProjectDocs.graphics &&
          this.mainProjectDocs.graphics.images
        ) {
          return this.mainProjectDocs.graphics.images;
        }
        return [];
      } else {
        return this.formData.images;
      }
    },
    imagesProjectId() {
      if (this.useMainProjectImages) {
        return this.docs.data.mainProjectId;
      } else {
        return this.project.idWorldProject;
      }
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.formData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.formData.lastUpdate
        ? this.$moment.unix(this.formData.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    sizesList() {
      return this.sizes
        .filter(
          (item) => item.modelName === this.sheetData.modelName && item.size
        )
        .sort((a, b) => a.size - b.size);
    },
  },
  methods: {
    saveForm(notCloseModal) {
      const docs = { ...this.docs };
      docs.graphics = this.formData;
      docs.graphics.lastUser = this.user.idWorldUser;
      docs.graphics.lastUpdate = this.$moment().unix();
      docs.measuresSheet = this.sheetData;
      this.$emit("save", docs);
      if (this.mode !== "prod" && notCloseModal !== true) {
        this.$anm22.eventBus.$emit("wg-modal-close");
      }
    },
    showPic(img) {
      this.picToShow = img;
      this.showDrawer = false;
      this.tabToShow = "pic";
    },
    closePic() {
      this.tabToShow = "default";
      this.picToShow = null;
    },
    addImage(data) {
      if (this.useMainProjectImages) {
        this.addImageToMainProject(data);
      } else {
        this.addImageToCurrentProject(data);
      }
    },
    addImageToMainProject(data) {
      const mainDocs = { ...this.mainProjectDocs };
      if (!mainDocs.graphics.images) {
        mainDocs.graphics.images = [];
      }
      mainDocs.graphics.images.push(data.url);
      mainDocs.graphics.lastUser = this.user.idWorldUser;
      mainDocs.graphics.lastUpdate = this.$moment().unix();
      this.$http
        .post(
          "vircos",
          {
            projectId: this.imagesProjectId,
            docs: mainDocs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData.images = response.data.docs.graphics.images;
          this.saveForm(true);
        })
        .catch((error) => {
          /* offline */
        });
    },
    addImageToCurrentProject(data) {
      if (!this.formData.images) {
        this.formData.images = [];
      }
      this.formData.images.push(data.url);
      const docs = { ...this.docs };
      docs.graphics = this.formData;
      docs.graphics.lastUser = this.user.idWorldUser;
      docs.graphics.lastUpdate = this.$moment().unix();
      this.$http
        .post(
          "vircos",
          {
            projectId: this.project.idWorldProject,
            docs: docs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData = response.data.docs.graphics;
        })
        .catch((error) => {
          /* offline */
        });
    },
    removeImage(index) {
      if (this.useMainProjectImages) {
        const docs = { ...this.mainProjectDocs };
        docs.graphics.images.splice(index, 1);
        docs.graphics.lastUser = this.user.idWorldUser;
        docs.graphics.lastUpdate = this.$moment().unix();
        this.$http
          .post(
            "vircos",
            {
              projectId: this.imagesProjectId,
              docs: docs,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$vlf("vircos-project-docs").setItem(
              String(response.data.docs.project),
              response.data.docs
            );
          })
          .catch((error) => {
            /* offline */
          });
      } else {
        this.formData.images.splice(index, 1);
        const docs = { ...this.docs };
        docs.graphics = this.formData;
        docs.graphics.lastUser = this.user.idWorldUser;
        docs.graphics.lastUpdate = this.$moment().unix();
        this.$http
          .post(
            "vircos",
            {
              projectId: this.project.idWorldProject,
              docs: docs,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$vlf("vircos-project-docs").setItem(
              String(response.data.docs.project),
              response.data.docs
            );
            this.formData = response.data.docs.graphics;
          })
          .catch((error) => {
            /* offline */
          });
      }
    },
    sendShareNotification() {
      if (this.docs.data.email) {
        this.formData.notificationDesign = this.$moment().unix();
        this.notificationSended = true;
        var productImage = null;
        // Cerco l'immagine da allegare
        if (this.formData.images) {
          productImage = this.$anm22.getImagePath(this.formData.images[0]);
        } else {
          console.log("Missing design image");
          return null;
        }
        this.$http
          .post(
            "vircos/sendShareNotification",
            {
              projectId: this.project.idWorldProject,
              email: this.docs.data.email,
              name: this.docs.data.name,
              surname: this.docs.data.surname,
              designImage: productImage,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log("Notification: Missing customer e-mail");
      }
    },
  },
  created() {
    this.formData = { ...this.docs.graphics };
    if (this.formData.notes && Array.isArray(this.formData.notes)) {
      if (this.formData.notes.length > 0) {
        this.formData.notes = this.formData.notes[
          this.formData.notes.length - 1
        ].note;
      } else {
        this.formData.notes = "";
      }
    }
    this.sheetData = { ...this.docs.measuresSheet };

    // Size retro
    if (this.sheetData.sizeSelected && !this.sheetData.modelName && !this.sheetData.sizeTop && !this.sheetData.sizeBottom) {
      const oldModelBases = this.sizes.filter(
        (item) => item.idVircosModelsBase == this.sheetData.sizeSelected
      );
      if (oldModelBases.length > 0) {
        const oldModelBase = oldModelBases[0];
        this.sheetData.modelName = oldModelBase.modelName;
        this.sheetData.sizeTop = oldModelBase.size;
        this.sheetData.sizeBottom = oldModelBase.size;
      }
    }
  },
  components: {
    Anm22FileUploader,
    PictureViewer,
    PictureDrawer,
  },
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-elem {
  width: 100%;
  max-width: 200px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.vircos-notification-send-btn {
  cursor: pointer;
  position: relative;
  padding: 6px 12px 6px 32px;
  background-color: #eee;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  &:hover {
    background-color: #ddd;
  }

  img {
    position: absolute;
    left: 10px;
    top: 6px;
    width: 16px;
  }
}
.vircos-notification-sended {
  position: relative;
  padding: 6px 12px 6px 22px;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  img {
    position: absolute;
    left: 0px;
    top: 6px;
    width: 16px;
  }
}
.pic-viewer {
  height: calc(90vh - 91px);
  width: 100%;
  justify-content: center;
  position: relative;
}
.edit-pic {
  position: absolute;
  top: 7px;
  right: 45px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.close-pic {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  z-index: 10;
  cursor: pointer;
}
@media print {
  .model-row {
    width: 541px !important;
    max-width: 541px !important;
  }
  .print-note {
    height: 541px !important;
  }

  .no-print {
    display: none;
  }
}
</style>
